import { styled } from '@mui/material';

/**
 * Use this in conjunction with StickyContainer to create a sticky element that can be used in a page layout.
 * */
export const StickyElement = styled('div')<{ headerHeight: number }>(({ theme, headerHeight }) => ({
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'white',
    paddingBottom: 2,
    paddingTop: 2,
    position: 'sticky',
    top: theme.spacing(headerHeight),
    // We subtract because this should be above everything on the page, except for any floating element, of which the mobile stepper has the lowest z-index
    zIndex: theme.zIndex.mobileStepper - 10,
  },
}));
